import React from 'react'
import { Box, Skeleton } from '@mui/material'
import SegmentBaggageLoader from '../segmentBaggageLoader'

const FlightSegment = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'top', py: 1.25, gap: 1 }}>
            <Box sx={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                {/* Airline Info */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        minWidth: '90px',
                        width: '90px'
                    }}
                >
                    <Skeleton variant="rectangular" width={40} height={40} sx={{ mb: 1, borderRadius: 1 }} />
                    <Skeleton variant="text" width={70} height={16} />
                    <Skeleton variant="text" width={50} height={14} />
                    <Skeleton variant="text" width={60} height={14} />
                </Box>

                {/* Flight Timeline */}
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', position: 'relative' }}>
                    {/* Departure */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <Skeleton variant="text" width={60} height={24} />
                        <Skeleton variant="text" width={40} height={20} />
                        <Skeleton variant="text" width={120} height={16} />
                    </Box>

                    {/* Flight Path */}
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, position: 'relative' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mr: 2 }}>
                            <Skeleton variant="circular" width={8} height={8} />
                            <Skeleton variant="rectangular" width={2} height={32} />
                            <Skeleton variant="circular" width={8} height={8} />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Skeleton variant="text" width={80} height={16} />
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 2 }}>
                                {[...Array(5)].map((_, i) => (
                                    <Skeleton key={i} variant="circular" width={20} height={20} />
                                ))}
                            </Box>
                        </Box>
                    </Box>

                    {/* Arrival */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Skeleton variant="text" width={60} height={24} />
                        <Skeleton variant="text" width={40} height={20} />
                        <Skeleton variant="text" width={120} height={16} />
                    </Box>
                </Box>
            </Box>

            {/* Baggage Loading */}
            <Box>
                <SegmentBaggageLoader />
            </Box>
        </Box>
    )
}

export default FlightSegment
